<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXABExternalFormsCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.externalform.list.noExternalForms') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('global.title') }}</th>
            <th>{{ $t('views.externalform.list.linkToPage') }}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ item.title }}</td>
            <td>
              <b-form-textarea
              rows="3"
              :readonly="true"
              :no-resize="true"
              v-model="item.linkToPage"
            ></b-form-textarea>
              <b-badge class="float-left mt-1" variant="danger"><i class="fa fa-exclamation-triangle"></i> {{$t("views.externalform.list.requirmentInformation")}}</b-badge>
            </td>
            <td>
              <div class="btn-group">
                <button type="button" class="btn btn-sm btn-link fa fa-edit fa-lg" @click="editItem(item)" v-b-tooltip.hover :title="$t('buttons.edit')"></button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'

export default {
  name: 'List',
  components: {
    BaseTableWrapper,
    Pagination,
    Loader
  },
  data () {
    return {
      searchParams: {
        state: 1
      }
    }
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABExternalFormsList')
  },
  props: ['item'],
  computed: {
    ...mapGetters({
      error: 'externalforms/list/error',
      items: 'externalforms/list/items',
      isLoading: 'externalforms/list/isLoading',
      view: 'externalforms/list/view'
    }),
    ableToCreateExternalForm () {
      return checkPermission('exabagreements', 'EXABExternalFormsCreate')
    }
  },
  created () {
    this.getPage(addParamsToQuery('e_x_a_b_external_forms', this.searchParams))
  },
  methods: {
    ...mapActions({
      getPage: 'externalforms/list/getItems'
    }),
    editItem (item) {
      this.$router.push({ name: 'EXABExternalFormsUpdate', params: { id: item['@id'] } })
    }
  }
}
</script>

<style scoped>

</style>
